<template>
<div class="chapter">
<div class="inner_page">
<p class="end-center"><span><a href="https://theportalist.com/subscribe/?utm_source=In%20Book%20Ad&amp;utm_medium=referral" target="_blank"><img alt="image" class="svg" src="Backed/img/port-backad.jpg"/></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// portalist_ad.vue?d58dda1a